// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__W-UrT","subheader":"ReorderModal_subheader__1vTw2","listWrap":"ReorderModal_listWrap__3UHa7"};